import * as React from 'react';
import * as _ from 'lodash';
import {
    SearchFieldContainer, SearchFieldNormal, SearchFieldHighlighted, SearchFieldContentBag

} from './styles'
import { Label } from 'common/baseComponents';

export interface SearchFieldProps {
    field: string,
    searchTerm: string,
    ignoreCase?: boolean;
    flexWrap?: boolean;
}

export class SearchedField extends React.Component<SearchFieldProps, SearchFieldProps> {

    constructor(props: SearchFieldProps) {
        super(props);
    }

    getSplitText = () => {
        if (!this.props.ignoreCase) {
            return this.getSplitTextWithoutIgnoringCase();
        }
        return this.getSplitTextIgnoringCase();
    }

    getSplitTextWithoutIgnoringCase = () => {
        const splitField = this.props.field.split(this.props.searchTerm);
        const fieldsWithSearchTerm = _.flatMap(splitField, (value, index, array) =>
            array.length - 1 !== index // check for the last item
                ? [value, this.props.searchTerm]
                : value
        );
        return fieldsWithSearchTerm;
    }

    getSplitTextIgnoringCase = () => {
        const splitFieldWithoutCase = this.props.field.toLowerCase().split(this.props.searchTerm.toLowerCase());
        const splitField: string[] = [];

        let currentIndex = 0;
        splitFieldWithoutCase.forEach((splitF, index) => {
            let str = "";
            for (let i = 0; i < splitF.length; i++) {
                str += this.props.field[currentIndex];
                currentIndex++;
            }
            splitField.push(str);

            if (index !== splitFieldWithoutCase.length - 1) {
                let str2 = "";
                for (let i = 0; i < this.props.searchTerm.length; i++) {
                    str2 += this.props.field[currentIndex];
                    currentIndex++;
                }
                splitField.push(str2);
            }
        })

        return splitField;
    }

    renderText(text: string, SearchField: any): JSX.Element[] {
        const splitText = text.split(" ");
        return splitText.map((txt, index) => {
            if (index !== splitText.length - 1) {
                return (
                    <SearchField key={txt}>
                        { txt}
                        &nbsp;
                    </SearchField>
                );
            }
            else {
                return (
                    <SearchField key={txt}>
                        { txt}
                    </SearchField>
                )
            }
        })
    }

    render() {
        if (this.props.field && this.props.searchTerm !== "") {
            const items = this.getSplitText();
            return (
                <SearchFieldContainer>
                    {
                        items.map((i, index) => {
                            if (index % 2 == 0) {
                                return (
                                    <SearchFieldContentBag key={i}>
                                        {
                                            this.renderText(i, SearchFieldNormal)
                                        }
                                        {
                                            index !== items.length - 1 &&
                                            this.renderText(items[index + 1], SearchFieldHighlighted)
                                        }
                                    </SearchFieldContentBag>
                                )
                            }
                            return null;
                        })
                    }
                </SearchFieldContainer>
            )
        }
        return (
            <SearchFieldNormal>
                {
                    this.props.field
                }
            </SearchFieldNormal>
        )
    }
}